import React from 'react';
import { Row, Col } from 'antd';
import LineitemBox from "../LineitemBox";

const LineitemList = ({ project, lineitems }) => {
  
  const list = lineitems.map((l, i) => 
    <Col className="line-item-cont" key={i}>
      <LineitemBox lineitem={l} width="350px" height="120px"/>
    </Col>
  )

  return (
    <div className="panel">
      <button className="axiom-button-button-icon round">
        {lineitems.length}
      </button> 
      Associated line items for {project.getTitle()} project. <span className="grey-text">Project id: {project.getId()}</span>
      <Row type="flex">
        {list}
      </Row>
    </div>
  )
}

LineitemList.defaultProps = {
  lineitem: {},
}

export default LineitemList